import React, { useCallback, useContext, useEffect, useState } from 'react'
import InlineTip from 'app/React/Components/misc/InlineTip'
import { getCurrentPrice, getSecurityDeposit } from 'app/React/Helpers/PriceHelper'
import Price from 'app/React/Components/Footer/Price'
import PropTypes from 'prop-types'
import '@reach/tooltip/styles.css'
import '../style.scss'
import SettingContextStep2 from "app/React/Components/Form/Step2/SettingContextStep2";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function OptionStep2(props) {
  const {
    cartItems,
    currentEngineTransmission,
    currentVariant,
    identifier,
    order,
    strings,
    setInteriorImage,
    setOrder,
    defaultValidateSteps
  } = useContext(ConfiguratorContext)

  const {
    getCheckedForSetting,
    markChecked,
    markUnchecked,
    isChecked
  } = useContext(SettingContextStep2)

  const [hasBeenLoaded, setHasBeenLoaded] = useState(false)

  const inDepositLabel = strings.footer?.in_security_deposit_leasing ?? 'i udbetaling'

  const option = props.option
  const inputName = 'option' + props.settingid
  const inputValue = option.id

  const hidden = option.hide_on === order.paymentType || option.hide_on === 'all'

  useEffect(() => {
    if (!hasBeenLoaded) {
      return
    }

    if (!isChecked(props.option.id)) {
      updateConfiguration(true)

      setInteriorImage(null)
      updateValue(true)
    } else {
      updateConfiguration(false)

      const settingsOptions = currentVariant.steps?.[2].settings?.[props.settingid]?.options ?? {}
      const settingsOption = Object.values(settingsOptions).find(settingsOption => settingsOption.id == props.option.id) ?? null

      setInteriorImage(settingsOption)
      updateValue(false)
    }
  }, [isChecked(props.option.id)])

  const onClick = function () {
    if (isChecked(props.option.id)) {
      markUnchecked(props.option.id, props.option.option_selectable_rules_option)
    } else {
      markChecked(props.option.id, props.settingid)
    }
  }

  function updateConfiguration(shouldDelete, checkedForSettings = null) {
    const updatedConfiguration = { ...order.configuration }

    if (shouldDelete) {
      if (updatedConfiguration?.chargings.hasOwnProperty(props.settingid)) {
        if (updatedConfiguration?.chargings[props.settingid]?.length <= 1) {
          const { [props.settingid]: _, ...newUpdatedConfiguration } = updatedConfiguration?.chargings
          updatedConfiguration.chargings = newUpdatedConfiguration
        } else {
          const index = updatedConfiguration?.chargings[props.settingid]?.indexOf(props.option.id)
          if (index > -1) {
            updatedConfiguration?.chargings[props.settingid].splice(index, 1)
          }
        }
      }
    } else {
      const settingid = String(props.settingid)
      checkedForSettings = checkedForSettings ?? getCheckedForSetting(settingid)

      updatedConfiguration.chargings = { ...updatedConfiguration.chargings, ...{ [settingid]: checkedForSettings } }
    }

    order.configuration = updatedConfiguration
    setOrder({ ...order })
  }

  const updateValue = useCallback(
    function (shouldDelete, option = props.option) {
      if (hidden) {
        return
      }

      if (typeof shouldDelete !== 'boolean') {
        shouldDelete = false
      }

      if (typeof props.onChange === 'function' && !shouldDelete) {
        const shouldStillUpdate = props.onChange(props.settingid, option)

        if (shouldStillUpdate !== true) {
          return
        }
      }

      order.price = getCurrentPrice(order.paymentType, order, currentVariant, cartItems)
      order.security_deposit = getSecurityDeposit(order.paymentType, order, currentVariant, currentEngineTransmission, cartItems)

      setOrder({ ...order })

      defaultValidateSteps()
    },
    [
      order.configuration,
      hidden,
      identifier,
      order,
      order.paymentType,
      props,
      setOrder,
      defaultValidateSteps
    ]
  )

  const htmlId = 'option' + props.settingid + '_' + props.option.id + (props.htmlIdPostfix ? '_' + props.htmlIdPostfix : '')

  const displayPrice = function () {
    if (order.paymentType !== 'leasing' || option.use_leasing_price === '0') {
      if (typeof props.option.price !== 'undefined') {
        return (
          <>
            {props.option.price > 0 && (<span>+</span>)}
            <Price price={props.option.price} format='cash'/>
          </>
        )
      }
    } else {
      if (typeof props.option.price_leasing !== 'undefined') {
        return (
          <>
            <div>
              {props.option.price_leasing > 0 && (<span>+</span>)}
              <Price price={props.option.price_leasing}/>
            </div>

            {
              typeof props.option.security_deposit_leasing !== 'undefined' && props.option.security_deposit_leasing > 0 && (
                <div>
                  <span>+</span>
                  <Price price={props.option.security_deposit_leasing} format='cash'/>
                  <span>{inDepositLabel}</span>
                </div>
              )
            }
          </>
        )
      }
    }

    return null
  }

  useEffect(() => {
    setHasBeenLoaded(true)
  }, [])

  // endregion
  return (
    <>
      <input
        id={htmlId}
        type={props.required && props.required !== '0' ? 'radio' : 'checkbox'}
        name={inputName}
        value={inputValue}
        checked={isChecked(props.option.id)}
        data-checked={isChecked(props.option.id)}
        onChange={updateValue}
        onClick={onClick}
        required={props.required}
      />
      <label
        htmlFor={htmlId}
        className='option'
        layout={props.layout}
      >
        {option.color_hex.substr(0, 1) === '#' ? (
          <span className='color' style={{ backgroundColor: option.color_hex }}/>
        ) : null}
        {typeof option.image_url === 'string' && option.image_url.length >= 0 ? (
          <img className='image' src={option.image_url} alt=''/>
        ) : null}
        <div>{option.title?.length > 0 ? option.title : option.name}</div>
        <div className='description'>
          {option.description_override ? (
            <span dangerouslySetInnerHTML={{ __html: option.description_override }}/>
          ) : (
            <>
              {displayPrice()}
              {option?.description_title?.length > 0 && option?.description?.length > 0 ? (
                <InlineTip button='Ok' label={option.description_title} content={option.description}/>
              ) : null}
              {option?.description_title?.length > 0 && !option?.description?.length > 0 ? (
                <span dangerouslySetInnerHTML={{ __html: option.description_title }}/>
              ) : null}
            </>
          )}
        </div>
      </label>
    </>
  )
}

OptionStep2.defaultProps = {
  onChange: null,
  hide_on: 'none'
}
OptionStep2.propTypes = {
  layout: PropTypes.any,
  checked: PropTypes.any,
  settingid: PropTypes.any,
  htmlIdPostfix: PropTypes.any,
  setChecked: PropTypes.any,
  onChange: PropTypes.any,
  required: PropTypes.any,

  option: PropTypes.shape({
    id: PropTypes.any,
    name: PropTypes.any,
    color_hex: PropTypes.any,
    image_url: PropTypes.any,
    min_price_leasing: PropTypes.any,
    security_deposit_leasing: PropTypes.any,
    variant_index: PropTypes.any,
    price: PropTypes.any,
    min_price: PropTypes.any,
    use_leasing_price: PropTypes.any,
    option_selectable_rules_option: PropTypes.any,
    option_selectable_rules_is_selected: PropTypes.any,
    hide_on: PropTypes.any,
    price_leasing: PropTypes.any,
    title: PropTypes.any,
    description: PropTypes.any,
    description_override: PropTypes.any,
    description_title: PropTypes.any
  })
}
